if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector('.js-results-container');
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector('.js-message-error');
      this.drawer = this.closest('.js-drawer');
      this.searchSuggestions = this.drawer?.querySelector('.search-drawer__suggestions');
      this.timeout = null;
      this.isOpen = false;
      this.request = null;
      if (!this.input || !this.resultsContainer || !this.errorMessageContainer) return;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timeout);
        this.request?.abort();
        const term = this.input.value.trim();
        this.btnClearText.disabled = !term;
        if (!term) { this.close(false); return; }
        this.timeout = setTimeout(() => this.getSearchResults(term), 300);
      });
      this.input.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        if (this.input.value) this.close();
        else this.closest('search-drawer')?.toggleDrawer();
      });
      this.btnClearText.addEventListener('click', () => this.close());
    }
    setDrawerHeight(open) {
      if (this.drawer && window.innerWidth <= 990) this.drawer.style.height = open ? '100%' : '';
      if (this.searchSuggestions) this.searchSuggestions.style.display = open ? 'none' : '';
    }
    async getSearchResults(searchTerm) {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      try {
        const response = await fetch(
          Shopify.routes.root + 'search/suggest?q=' + encodeURIComponent(searchTerm) +
          '&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search',
          { signal: request.signal }
        );
        if (!response.ok) throw new Error('Search unavailable');
        const text = await response.text();
        if (request.signal.aborted || this.input.value.trim() !== searchTerm) return;
        const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        if (!section) throw new Error('Search unavailable');
        this.resultsContainer.innerHTML = section.innerHTML;
        const searchForm = this.querySelector('[data-qf-search-form]');
        this.resultsContainer.querySelectorAll('.predictive-search__link[type="submit"]').forEach(button => {
          button.setAttribute('form', searchForm.id);
        });
        const resultRoot = this.resultsContainer.querySelector('#predictive-search-results');
        if (resultRoot) resultRoot.id = this.input.id + '-suggestions';
        this.open();
        document.querySelector('quick-cart-drawer')?.initTriggers();
      } catch (error) {
        if (request.signal.aborted || this.input.value.trim() !== searchTerm) return;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }
    open() {
      this.isOpen = true;
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.setAttribute('aria-expanded', 'true');
      this.btnClearText.disabled = false;
      this.setDrawerHeight(true);
    }
    close(focus = true) {
      clearTimeout(this.timeout);
      this.request?.abort();
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.setAttribute('aria-expanded', 'false');
      this.btnClearText.disabled = true;
      this.setDrawerHeight(false);
      if (focus) this.input.focus();
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
}
